import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

const styles = {};

class OrderReopenDialog extends Component {

  handleClose = () => {
    this.props.onClose(this.props.orderReopenStatus);
  };

  handleListItemClick = value => {
    this.props.onClose(value);
  };

  render() {
    const { classes, onClose, orderType, changeList, ...other } = this.props;
    const message1 = `Changing rates, dates, creative sizes, or adding/removing targeted placements on an already accepted proposal will require that the buyer re-accept the proposal before the changes are effective. You changed these fields requiring renegotiation:`;
    const message2 = `If you proceed with saving the changes you made, 
    you will re-open the proposal and will need to request buyer acceptance again.`;
    const changeBullets = changeList.map(ch => `${ch}`).join(', ');
    return (
      <Dialog onClose={this.handleClose} aria-labelledby="simple-dialog-title" {...other}>
        <DialogTitle id="simple-dialog-title">Do you want to renegotiate with the buyer?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {message1}
          </DialogContentText>
          <DialogContentText>
            {changeBullets}
          </DialogContentText>
          <DialogContentText>
            {message2}
          </DialogContentText>
          <DialogActions>
            <Button onClick={() => this.handleListItemClick('Cancel')}>
              Cancel
            </Button>
            <Button onClick={() => this.handleListItemClick('Reopen')} color="primary">
              Save & Renegotiate
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    )
  }
}

OrderReopenDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  changeList: PropTypes.array.isRequired
};

export default withStyles(styles)(OrderReopenDialog);
